import {List} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {TitleRow} from '..';
import {groupBy, px, weekDaysSorter} from '../../../utils';
import TimeTableCol from './TimeTableCol';

const TimeTable = ({
  data = [],
  hideTitle = false,
  containerStyle,
  selectedCards,
  onCardSelect,
  useTimeTablePageStyle,
}) => {
  const sortedDataByWeekDay = weekDaysSorter(data, 'weekDay');
  const groupedData = groupBy(sortedDataByWeekDay, 'weekDay');

  const renderItem = ({item, index}) => (
    <TimeTableCol
      key={index}
      items={item}
      day={item[0].weekDay}
      selectedCards={selectedCards}
      onCardSelect={onCardSelect}
      useTimeTablePageStyle={useTimeTablePageStyle}
    />
  );

  return (
    <View style={[styles.container, containerStyle]}>
      {!hideTitle && (
        <TitleRow
          title="Timetable"
          type="secondary"
          containerStyle={styles.title}
        />
      )}
      <List
        contentContainerStyle={styles.list}
        vertical
        data={Object.values(groupedData)}
        renderItem={renderItem}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: px(17),
    width: '100%',
  },
  title: {
    paddingHorizontal: 0,
  },
  list: {
    backgroundColor: '#FFF',
  },
});

export default TimeTable;
